import { Box, Button, Stack, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import Header from "../main/Header";
import dynamic from "next/dynamic";
import { LandingFooterDefault } from "../../components/LandingFooterDefault/LandingFooterDefault";
import { useRouter } from "next/router";
import { useTranslation } from "../../../fe-ui/hooks/use-translation";
import { Link } from "../../../fe-ui/atoms/Link/Link";
import { CLIENT_ID, USER_REALM } from "../../../@types/roleModel";
import { AuthProvider } from "../../../controllers/AuthController";

const CookieBanner = dynamic(
  () => import("../../../fe-ui/blocks/CookieBanner/CookieBanner").then((x) => x.CookieBanner),
  {
    ssr: false,
  }
);

export const LandingApplyLayout = ({ children }) => {
  const t = useTranslation();
  const router = useRouter();
  const { asPath, pathname } = router;
  const [, tabsValue] = pathname.split("/apply/");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <AuthProvider realm={USER_REALM.owners} client_id={CLIENT_ID.owners}>
      <Header
        renderHeaderContent={() => (
          <Stack
            direction={"row"}
            px={2}
            alignContent={"center"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            {isDesktop && (
              <Stack flexGrow={1} alignContent={"center"} alignItems={"center"} justifyContent={"space-between"}>
                <Tabs value={tabsValue} sx={{ alignSelf: "center" }}>
                  <Tab
                    sx={{
                      textDecoration: "none !important",
                    }}
                    LinkComponent={Link}
                    href="/info/apply/for-private-owners"
                    value={"for-private-owners"}
                    label={t("apply_landing_topmenu_1")}
                  />
                  <Tab
                    sx={{
                      textDecoration: "none !important",
                    }}
                    LinkComponent={Link}
                    href="/info/apply/trust-management"
                    value={"trust-management"}
                    label={t("apply_landing_topmenu_2")}
                  />
                  <Tab
                    sx={{
                      textDecoration: "none !important",
                    }}
                    LinkComponent={Link}
                    href="/info/apply/for-hotels"
                    value={"for-hotels"}
                    label={t("apply_landing_topmenu_3")}
                  />
                </Tabs>
              </Stack>
            )}
            <Button
              href={asPath === "/info/about-us" ? "/info/apply" : "#footer-contact-form"}
              component={Link}
              size="small"
              variant="contained"
              color="primary"
              sx={{ whiteSpace: "nowrap", px: 2 }}
            >
              {t("apply_landing_topmenu_cta")}
            </Button>
          </Stack>
        )}
        enableMobileNav
        mobileNavItems={[
          { title: t("apply_landing_topmenu_1"), path: "/info/apply/for-private-owners" },
          { title: t("apply_landing_topmenu_2"), path: "/info/apply/trust-management" },
          { title: t("apply_landing_topmenu_3"), path: "/info/apply/for-hotels" },
        ]}
      />

      <Box
        component={"main"}
        sx={{
          flexGrow: 1,
          pt: { xs: 8, md: 11 },
        }}
      >
        {children}
      </Box>
      <CookieBanner />
      <LandingFooterDefault />
    </AuthProvider>
  );
};
